<template>
	
	<div class="wizard-component with-tipsbox">

		<div class="tipsbox" v-for="tip in tipsbox">
			<p>{{ tip.content }}</p>
		</div>

	</div>

</template>


<script>
	import {mapGetters} from 'vuex';
    import {store} from '../../../store/index'
    export default {
	

		data: () => ({
			tipsbox: [
				{
					content: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce quis lectus quis sem lacinia nonummy. Proin mollis lorem non dolor.'
				}
			]

		})

	}
</script>


<style></style>